import React, { useEffect } from "react";
// import '../Doc/AdminNavigation.css'
// import "bootstrap/dist/css/bootstrap.min.css";
import Logo from "../../images/Logo.svg";
// import  from 'react-bootstrap/Dropdown';
// import ProfileIcon from '../Images/ProfileIcon.svg'
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Col, Container, Navbar, Row, Nav, Button } from "react-bootstrap";
import footerLogo from "../../images/footerLogo.svg";

function WebSiteHeader() {
  const location = useLocation();

  // useEffect(() => {
  //   alert(location.pathname)
  // },[location]);

  const getActiveClass = (path) => (location.pathname === path ? "active" : "");

  return (
    <Row className="m-0">
      <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary">
        <Container>
          <Navbar.Brand>
            <img src={Logo} alt="" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link
                as={Link}
                to="/home"
                className={`uniteColorBold ${getActiveClass("/home")}`}
              >
                Home
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/about"
                className={`uniteColorBold ${getActiveClass("/about")}`}
              >
                About
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/blog"
                className={`uniteColorBold ${getActiveClass("/blog")}`}
              >
                Blog
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/contact"
                className={`uniteColorBold ${getActiveClass("/contact")}`}
              >
                Contact
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/login"
                className={`uniteColorBold ${getActiveClass("/login")}`}
              >
                Login
              </Nav.Link>
            </Nav>
            {location.pathname.toLowerCase() !== "/signup" && <Nav>
              <Nav.Link
                as={Link}
                to="/signUp"
                className="uniteColorBold text-center"
              >
                <Button className="uniteButton-lg ">Join Now</Button>
              </Nav.Link>
            </Nav>}
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Row className="content">
        <Outlet />
      </Row>
      <Row className="unitedbgColor py-5 m-0">
        <Col>
          <div></div>
        </Col>
        <Col xl={12} align="middle" className="py-2">
          <Col xl={10} className="d-flex  justify-content-between mb-3">
            <img src={footerLogo} alt="footerLogo.png" ></img>
            {/* <div className="d-flex align-items-center">
              <img style={{ paddingLeft: "7px" }} src={insta} alt="logi1" />
              <img style={{ paddingLeft: "7px" }} src={mail} alt="logi1" />
              <img style={{ paddingLeft: "7px" }} src={facebook} alt="logi1" />
              <img style={{ paddingLeft: "7px" }} src={linkedin} alt="logi1" />
            </div> */}
          </Col>
          <Col xl={10} className="d-flex list-unstyled gap-3 mb-3">
            <li>
              <Link className="text-decoration-none textWhite" to="/home">
                Home
              </Link>
            </li>
            <li>
              <Link className="text-decoration-none textWhite" to="/about">
                About
              </Link>
            </li>
            <li>
              <Link className="text-decoration-none textWhite" to="/blog">
                Blog
              </Link>
            </li>
            <li>
              <Link className="text-decoration-none textWhite" to="/contact">
              Contact
              </Link>
            </li>
          </Col>
          <Col xl={10} style={{ textAlign: "left" }}>
            <p className="textBlue">
              © Copyright 2024 United Docs Marketplace, LLC. Patent US Nos.
              7752,060 and 8,170,952. All Rights Reserved. United Docs is a
              Canadian digital healthcare company. Third Party materials
              included herein protected under copyright law.
            </p>
            <p className="textBlue">
              Use of this website and any information contained herein is
              governed by the United Docs User Agreement. The content on United
              Docs does not provide medical advice. Always consult a medical
              provider for diagnosis and treatment.
            </p>
          </Col>
        </Col>
      </Row>
    </Row>
  );
}

export default WebSiteHeader;
